import { motion } from 'framer-motion';

const terms = [
    "All bookings are subject to availability and confirmation. A valid ID must be provided at the time of check-in.",
    "Cancellation terms follow the policy outlined during booking. Refunds are processed per the policy.",
    "Early check-in or late check-out is subject to availability and may incur additional charges.",
    "Payments must be completed through the Airbnb platform or approved methods. Any outstanding dues must be settled before check-in.",
    "Guests must follow house rules, including no smoking indoors, no parties, and maintaining quiet hours.",
    "A refundable security deposit may be required and will be returned after a satisfactory inspection of the property.",
    "Guests are responsible for any damages caused during their stay and may be charged accordingly.",
    "Pets are not allowed inside the apartment.",
    "Znorm homes are not responsible for any loss, injury, or damage to personal property during the stay.",
    "Personal information provided by guests will only be used for booking and communication purposes.",
    "It reserves the right to terminate guests' stay without refund in case of policy violation."
];

const TermsofUses = () => {
    return (
        <>
          
            <div
                className="relative h-[656px] md:h-[464px] lg:h-[524px] w-full bg-cover bg-center flex flex-col justify-center items-center text-center "
                style={{
                    backgroundImage: `url('/images/TermsAndConditions/image1.webp')`, 
                }}
            >
                <div className="absolute inset-0 bg-black bg-opacity-20"></div>
                <div className="relative z-10 text-white px-6 sm:px-10 max-w-2xl">
                 
                    <h2 className="lora-display mb-4">
                        Terms and Conditions
                    </h2>

                    {/* <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold mb-4">
                        Articles & Resources
                    </h1> */}
                    {/* Description */}
                    <p className="outfit text">
                        Effective date january 25 2025
                    </p>
                </div>
            </div>

        
           <section className="flex flex-col justify-center items-center w-full lg:px-[106px] md:px-[64px] px-4 lg:my-[200px] md:my-[180px] my-[100px]">
                <div className="lg:w-[1025px] md:w-[706px] w-full mx-auto bg-white rounded-[24px] shadow-[0_4px_24px_rgba(0,0,0,0.06)] border border-gray-100 p-6 md:p-10 lg:p-16">
                    <div className="space-y-6 md:space-y-8">
                        {terms.map((term, index) => (
                            <motion.div 
                                key={index}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, amount: 0.2 }}
                                transition={{ duration: 0.5, delay: index * 0.1 }}
                                className="flex items-start gap-4 md:gap-6 pb-6 border-b border-gray-100 last:border-0 last:pb-0"
                            >
                                <div className="flex-shrink-0 w-8 h-8 md:w-10 md:h-10 rounded-full bg-[#F1F3ED] text-[#668B42] flex items-center justify-center font-lora text-[14px] md:text-[18px] font-bold shadow-sm">
                                    {index + 1}
                                </div>
                                <p className="text-[#333333] outfit-text pt-1 md:pt-2 leading-relaxed">
                                    {term}
                                </p>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>



           

        </>
    )
}
export default TermsofUses